import { render } from "./PyramidNumbersPad.vue?vue&type=template&id=a8487f62&scoped=true"
import script from "./PyramidNumbersPad.vue?vue&type=script&lang=js"
export * from "./PyramidNumbersPad.vue?vue&type=script&lang=js"

import "./PyramidNumbersPad.vue?vue&type=style&index=0&id=a8487f62&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a8487f62"

export default script